import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import React from 'react'

import HHDisplayMoney from 'components/common/HHDisplayMoney'
import Link from 'components/common/Link'
import { getWorkOrderPriceCents } from 'components/customer-details/content/work-orders/utils'
import ServiceActionTypeHelper from 'components/services/ServiceActionTypeHelper'
import WorkOrderStatusChip from 'components/work-order/WorkOrderStatusChip'
import { getWorkOrderDetailsPageUrl } from 'router/routes'
import { formatDateToFEFormatDateFns } from 'utils/date'

type SelectedDayWorkOrder = {
  workOrderId: string
  workOrderNumber?: string
  serviceActionName?: string
  eventActionType?: string
  pricedServiceType?: string
  workOrderStatus?: string
  completionStatus?: string | null
  intentStatus?: string | null
}

type Props = {
  selectedDay?: Date | null
  workOrders?: SelectedDayWorkOrder[]
}

const SelectedDayWorkOrders: React.FC<Props> = ({ selectedDay, workOrders = [] }) => {
  if (!selectedDay || workOrders.length === 0) {
    return null
  }

  return (
    <Box>
      <Stack spacing={1}>
        {workOrders.map(workOrder => {
          const totalCents = getWorkOrderPriceCents(workOrder)
          return (
            <Box
              key={workOrder.workOrderId}
              sx={{
                display: 'flex',
                alignItems: 'stretch',
                justifyContent: 'space-between',
                gap: 1,
                flexDirection: 'column',
              }}
            >
              <Box>
                <Box alignItems="center" display="flex" gap={1}>
                  <Link color="info.light" fontWeight={500} to={getWorkOrderDetailsPageUrl(workOrder.workOrderId)} variant="body2">
                    {workOrder.workOrderNumber}
                  </Link>
                  <Divider flexItem orientation="vertical" />
                  {totalCents > 0 && (
                    <Typography color="textPrimary" fontWeight={700} variant="body2">
                      <HHDisplayMoney value={totalCents} />
                    </Typography>
                  )}
                </Box>
                <Typography color="textSecondary" variant="caption">
                  {formatDateToFEFormatDateFns(selectedDay)}
                </Typography>
              </Box>
              <Box alignItems="center" display="flex" gap={1} justifyContent="space-between">
                <ServiceActionTypeHelper
                  eventActionType={workOrder.eventActionType}
                  serviceActionType={workOrder.serviceActionName}
                  serviceType={workOrder.pricedServiceType}
                />
                <WorkOrderStatusChip
                  intentStatus={workOrder.intentStatus ?? undefined}
                  status={workOrder.completionStatus || workOrder.workOrderStatus}
                />
              </Box>
            </Box>
          )
        })}
      </Stack>
    </Box>
  )
}

export default SelectedDayWorkOrders
